import {memo} from 'react';

import styled from 'styled-components';

import {media, flipOnLTR} from '~/shared/theme/utils';
import {generatePriceLabel} from '~/shared/components/PriceLabels';
import {body16Bold} from '~/shared/theme/typography';
import {RippleLoader, SkeletonLoader} from '~/shared/components/Loaders';
import {SkeletonButton} from '~/shared/components/Loaders/components';
import {FlexCenter} from '~/shared/theme/FlexLayout';
import PieButton from '~/shared/theme/pie/PieButton';

const SubmitButton = styled(PieButton).attrs({
  'data-test-id': 'checkoutSubmitOrderBtn',
  variant: 'primaryXL',
})`
  position: relative;
  width: calc(100% - 32px);
  height: 48px;
  ${body16Bold}
  text-align: center;
  cursor: pointer;
  margin-bottom: 8px;
  ${media.minLargeTablet`
    margin-bottom: 24px;
  `}

  &:disabled {
    background-color: ${({theme}) => theme.colors.gray500};
    cursor: not-allowed;
  }

  margin-right: auto;
  margin-left: auto;
  ${media.minLargeTablet`
    width: 100%;
    margin-right: inherit;
    margin-left: inherit;
    margin-bottom: 0px;
    ${flipOnLTR`
      margin-right:  ${({centerSubmitBtn}) => centerSubmitBtn && '154px'};
      margin-left: ${({centerSubmitBtn}) => centerSubmitBtn && '24px'};
    `}
  `}
`;

const LoaderContainer = styled(FlexCenter)`
  position: absolute;
  top: 0;
  ${flipOnLTR`
    right: calc(50% - 25px);
  `}
`;

const CheckoutSubmit = ({
  onCheckoutSubmit,
  label: translatedLabel,
  isDisabled,
  centerSubmitBtn,
  totalToCharge,
  isLoading,
  isSubmitting,
}) => (
  <SkeletonLoader shouldShowLoader={isLoading} LoaderComponent={SkeletonButton}>
    <SubmitButton centerSubmitBtn={centerSubmitBtn} onClick={onCheckoutSubmit} disabled={isDisabled}>
      {isDisabled && isSubmitting ? (
        <LoaderContainer>
          <RippleLoader size={50} />
        </LoaderContainer>
      ) : `${translatedLabel} (${generatePriceLabel({price: totalToCharge})})`}
    </SubmitButton>
  </SkeletonLoader>
);

export default memo(CheckoutSubmit);
